module.exports = __webpack_public_path__ + "static/media/roundedshoulder_severe_left.5c3b5366.png";